import * as React from 'react';
import { SVGProps } from 'react';

const IconChatStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.007 15c-.302 0-.504-.1-.705-.3-.302-.3-.403-.7-.201-1l1.107-3.4c-.402-.9-.503-1.7-.503-2.6 0-2.5 1.41-4.8 3.725-6 .907-.5 1.913-.7 2.92-.7h.302c3.424.2 6.143 2.9 6.344 6.3v.4c0 1-.201 2.1-.705 3-1.107 2.3-3.423 3.7-6.041 3.7-.907 0-1.813-.2-2.618-.5L2.208 15h-.201zM8.35 3c-.704 0-1.41.2-2.013.5a4.661 4.661 0 0 0-2.618 4.2c0 .7.201 1.4.503 2.1.1.2.1.5.1.8l-.603 1.9 1.913-.6c.302-.1.503-.1.805.1.604.3 1.41.5 2.115.5a4.7 4.7 0 0 0 4.229-2.6c.1-.8.302-1.5.302-2.2v-.4c-.1-2.3-2.014-4.2-4.43-4.3H8.35z" />
  </svg>
);
export default IconChatStrokedSizeS;
